export const API_BASE_URL = 'https://etracking.matarstars.com/api/v1';
export const MAP_API_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const MAP_BASE_URL =
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const EXAMPLE_UPLOAD_MARKER =
  'https://matarminhducvideo15days.s3.ap-southeast-1.amazonaws.com/Diem_202106251555.xlsx';
export const EXAMPLE_UPLOAD_FILE =
  'https://matarminhducvideo15days.s3.ap-southeast-1.amazonaws.com/ke+hoach+1.xlsx';
